import React from 'react'
import { Card, Flex, Text } from '@workwhile/ui'
import { defs } from 'components/Shared/defs'
import {
  JET_CALL_REPORT_STATUS_LABELS,
  JetCallReportStatus,
} from 'pages/Jet/shared/constants/status'
import { useJetStatusContextValue } from '../context/JetStatusProvider'

// The linear "happy path" a work item moves through.
const PRIMARY_STATUSES: JetCallReportStatus[] = [
  'scheduled',
  'in_progress',
  'pending',
  'synced',
]

// Off-ramps from the happy path, shown apart from it.
const SECONDARY_STATUSES: JetCallReportStatus[] = [
  'missed',
  'admin_review',
  'excluded',
]

export const JetStatusSummary = () => {
  const {
    state: { statusSummary, filters },
    actions: { setStatusFilter },
  } = useJetStatusContextValue()

  const countByStatus = new Map(
    statusSummary.map((item) => [item.status, item.count])
  )

  const isActive = (status: JetCallReportStatus) =>
    filters.statuses?.length === 1 && filters.statuses[0] === status

  const renderCard = (status: JetCallReportStatus) => (
    <StatusCard
      key={status}
      isActive={isActive(status)}
      onClick={() => setStatusFilter(status)}
    >
      <Text fontSize="xl" fontWeight="bold">
        {countByStatus.get(status) ?? 0}
      </Text>
      <Text color="lightText">{JET_CALL_REPORT_STATUS_LABELS[status]}</Text>
    </StatusCard>
  )

  return (
    <Flex gap={3} flexWrap="wrap" m={2}>
      {PRIMARY_STATUSES.map(renderCard)}
      {SECONDARY_STATUSES.map(renderCard)}
    </Flex>
  )
}

const StatusCard = ({
  isActive,
  onClick,
  children,
}: React.PropsWithChildren<{ isActive: boolean; onClick: () => void }>) => (
  <Card
    onClick={onClick}
    p={3}
    minWidth={140}
    style={{
      cursor: 'pointer',
      borderWidth: isActive ? 2 : 1,
      borderStyle: 'solid',
      borderColor: isActive ? defs.wwDarkTeal : 'transparent',
    }}
  >
    {children}
  </Card>
)
